import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTrips } from '@/context/TripsContext';
import { useState } from 'react';

export const AddTripCard = () => {
  const navigate = useNavigate();
  const { trips, createTrip } = useTrips();
  const [isCreating, setIsCreating] = useState(false);

  const handleAddTrip = async () => {
    try {
      setIsCreating(true);
      const tripNumber = trips.length + 1;
      const newTrip = await createTrip({
        nickname: `Trip #${tripNumber}`,
        currency: 'USD',
        total_budget: 0,
      });
      navigate(`/trip/${newTrip.short_id}`);
    } catch (error) {
      console.error('Error creating trip:', error);
      setIsCreating(false);
    }
  };

  return (
    <Card className="hover:shadow-lg transition-shadow">
      <CardContent className="flex flex-col items-center justify-center h-48 gap-6">
        <p className="text-2xl font-bold text-center">
          Add your next trip
        </p>
        <Button
          onClick={handleAddTrip}
          disabled={isCreating}
          className="w-20 h-20 rounded-full bg-black hover:bg-black/90 text-white disabled:opacity-50"
          aria-label="Add new trip"
        >
          <Plus className="w-10 h-10" />
        </Button>
      </CardContent>
    </Card>
  );
};
